/**
 * Welches Modul einen Belegtyp anbietet. Angebot, Auftragsabwicklung und Rechnungen teilen sich
 * denselben Vorgang (offerings); gesperrt wird deshalb je Belegtyp, nicht über den ganzen
 * /offerings-Prefix. Client und Server nutzen dieselbe Tabelle.
 */
import { type InstanceModuleKey, type InstanceModuleMap, isModuleEnabled } from './instanceModules';

/** Projektdokument (deutsches Label wie in PROJECT_DOCUMENT_TYPE_LABELS) → Modul. */
export const DOCUMENT_TYPE_MODULES: Readonly<Record<string, InstanceModuleKey>> = {
  Angebot: 'angebote',
  Kostenvoranschlag: 'angebote',
  'Auftragsbestätigung': 'auftraege',
  Lieferschein: 'auftraege',
  Arbeitsbericht: 'auftraege',
  Rechnung: 'rechnungen',
  Abschlagsrechnung: 'rechnungen',
  Schlussrechnung: 'rechnungen',
  Stornorechnung: 'rechnungen',
  Gutschrift: 'rechnungen',
};

/** Belegtyp in invoice_documents.document_type → Modul. */
export const LEDGER_DOCUMENT_TYPE_MODULES: Readonly<Record<string, InstanceModuleKey>> = {
  offer: 'angebote',
  invoice: 'rechnungen',
  partial_invoice: 'rechnungen',
  final_invoice: 'rechnungen',
  credit_note: 'rechnungen',
  invoice_correction: 'rechnungen',
  supplier_invoice: 'rechnungen',
  incoming_invoice: 'rechnungen',
  incoming_invoice_correction: 'rechnungen',
};

/** Modul eines Projektdokuments; null für unbekannte Labels. */
export function documentTypeModule(label: string | null | undefined): InstanceModuleKey | null {
  return DOCUMENT_TYPE_MODULES[String(label ?? '').trim()] ?? null;
}

/** Darf dieser Belegtyp angelegt oder geöffnet werden? Unbekannte Labels hängen nur an Projekte. */
export function isDocumentTypeAvailable(
  label: string | null | undefined,
  modules: Partial<InstanceModuleMap> | null | undefined,
): boolean {
  const owner = documentTypeModule(label);
  return isModuleEnabled(modules, owner ?? 'projekte');
}

export function ledgerDocumentTypeModule(type: string | null | undefined): InstanceModuleKey | null {
  return LEDGER_DOCUMENT_TYPE_MODULES[String(type ?? '').trim()] ?? null;
}
